import React from "react";

import { useQuery, useMutation } from "@apollo/client";

import {
  productCategoryListQuery,
  deleteProductCategoryMutation,
} from "graphql/productCategory";

import BaseList from "./BaseList";

function ProductCategoryList() {
  const { data: { productCategoryList = [] } = {} } = useQuery(
    productCategoryListQuery
  );

  const [deleteRow] = useMutation(deleteProductCategoryMutation, {
    update(cache, result) {
      const data = cache.readQuery({ query: productCategoryListQuery });
      const nextData = {
        productCategoryList: data.productCategoryList.filter(
          (productCategory) =>
            productCategory.id !== result.data.deleteProductCategory.id
        ),
      };
      cache.writeQuery({
        query: productCategoryListQuery,
        data: nextData,
      });
    },
  });

  const columns = [
    {
      header: "Name",
      body: (item) => item.name,
    },
  ];

  return (
    <BaseList
      title="Categories"
      rows={productCategoryList}
      deletePromise={deleteRow}
      columns={columns}
    />
  );
}

export default React.memo(ProductCategoryList);
